// Calculate distance between to lat lng points
export function calculateDistance(lat1: number, lon1: number, lat2: number, lon2: number) {
  var R = 6371e3; // metres
  var φ1 = toRadians(lat1);
  var φ2 = toRadians(lat2);
  var Δφ = toRadians(lat2 - lat1);
  var Δλ = toRadians(lon2 - lon1);

  var a =
    Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
    Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  return R * c;
}

function toRadians(degrees: number) {
  return (degrees * Math.PI) / 180;
}

// Get bounding box array around a point with a given distance in meters
export function getPointBoundingBox(lat: number, lng: number, distance: number) {
  const latRadian = toRadians(lat);
  const degLat = distance / 2 / 111320; // 1 degree latitude in meters
  const degLng = distance / 2 / (111320 * Math.cos(latRadian)); // 1 degree longitude in meters
  return [lng - degLng, lat - degLat, lng + degLng, lat + degLat];
}
